import React from 'react'
import '../Services_details.css';


export default function Services_MobileApp() {

    const Features1 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Authentication</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>5 - 8 Screens</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Profiles and Accounts</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>API Integrations</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>ChatBot Integrations</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Multi-Language Support</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Custom Admin Panel</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Push Notifications</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Features2 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Authentication</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>10 - 15 Screens</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Profiles and Accounts</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>API Integrations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>ChatBot Integrations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Multi-Language Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Custom Admin Panel</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Push Notifications</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Medium Performance</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Features3 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Authentication</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Screens (Your wish)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Profiles and Accounts</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>API Integrations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>ChatBot Integrations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Multi-Language Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Custom Admin Panel</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Push Notifications</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Ecommerce = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Custom Admin Panel</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Multi-Language Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Product listing Screen</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Product detail view</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Wishlist and favourites</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Search functionality</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Profile Screen</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Order History / Tracking</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="content-box">
            <h3 className="heading-main">Mobile App Development</h3>
            <p>
                We specialize in creating innovative and high-performance mobile applications for both Android and iOS platforms. Our approach ensures that your app delivers an exceptional user experience while leveraging the latest technologies.
            </p>
            <h4>Mobile App Development</h4>
            <p>
                We provide top-notch cross-platform mobile app development services using React Native. This approach allows us to build powerful and efficient apps for both Android and iOS platforms from a single codebase, ensuring a consistent and seamless user experience across all devices.
            </p>
            <h4>React Native Development</h4>
            <p>
                Our React Native development services include:
                <ul>
                    <li><strong>JavaScript & React</strong>: Leveraging the power of JavaScript and the React framework for high-performance apps.</li>
                    <li><strong>Cross-Platform Compatibility</strong>: Ensuring your app works flawlessly on both Android and iOS devices.</li>
                    <li><strong>Native Modules</strong>: Integrating native modules to access device-specific features and enhance functionality.</li>
                    <li><strong>Hot Reloading</strong>: Speeding up the development process with real-time updates.</li>
                </ul>
            </p>
            <h4>Key Aspects of Our Mobile App Development</h4>
            <p>
                We focus on:
                <ul>
                    <li><strong>UI/UX Design</strong>: Creating intuitive and engaging interfaces.</li>
                    <li><strong>Performance Optimization</strong>: Ensuring smooth and efficient operation.</li>
                    <li><strong>Security</strong>: Implementing robust measures to protect user data.</li>
                    <li><strong>Comprehensive Testing</strong>: Ensuring your app is bug-free and functions perfectly.</li>
                </ul>
            </p>
            <h4>Our Mobile App Development Process</h4>
            <p>
                Our development process includes:
                <ul>
                    <li><strong>Planning</strong>: Understanding your project requirements and defining the scope.</li>
                    <li><strong>Design</strong>: Creating wireframes and mockups for the app interface.</li>
                    <li><strong>Development</strong>: Building the app using React Native.</li>
                    <li><strong>Testing</strong>: Thoroughly testing the app to ensure it meets all requirements and functions flawlessly.</li>
                    <li><strong>Deployment</strong>: Launching the app on both Google Play Store and Apple App Store.</li>
                    <li><strong>Maintenance</strong>: Providing regular updates and improvements to keep the app running smoothly.</li>
                </ul>
            </p>

            <div className='packages'>
                <h2 className="heading">Packages</h2>
                <div className="packages-container">
                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Basic</h3>
                            <h4>Mobile App Development Package</h4>
                        </div>
                        <p>The Basic Package is perfect for beginners looking to get essential tools and guidance to launch their project or business confidently.
                        </p>

<Features1 />

                        <h4 className='cost'><strong>Cost: </strong>₹10,000 - ₹25,000</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Basic%20Package%20for%20Mobile%20App'
                            className='btn2'>
                            Contact for OFFERS
                        </a>

                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Pro</h3>
                            <h4>Mobile App Development Package</h4>
                        </div>
                        <p>The Pro Package is designed for businesses aiming to expand and scale. It includes advanced features and support to accelerate your growth trajectory.</p>

<Features2 />

                        <h4 className='cost'><strong>Cost: </strong>₹25,000 - ₹55,000</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Pro%20Package%20for%20Mobile%20App'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Pro-Plus</h3>
                            <h4>Mobile App Development Package</h4>
                        </div>
                        <p>The Pro-Plus Package offers comprehensive solutions tailored for established businesses seeking top-tier tools and personalized service to maintain leadership in their industry.</p>

<Features3 />

                        <h4 className='cost'><strong>Cost: </strong>₹55,000 - ₹X,XX,XXX</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Pro-Plus%20Package%20for%20Mobile%20App'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Ecommerce Plan</h3>
                            <h4>Mobile App Development Package</h4>
                        </div>
                        <p>Experience the pinnacle of ecommerce success with our Ecommerce Plan Package. Get top-tier tools and personalized service to keep your business at the forefront of the industry.</p>

<Ecommerce />

                        <h4 className='cost'><strong>Cost: </strong>₹55,000 - ₹X,XX,XXX</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Ecommerce%20Plan%20Package%20for%20Mobile%20App'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>
                </div>
            </div>

        </div>
    );
}
